var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "l-map",
        {
          staticStyle: { height: "400px", "z-index": "1" },
          attrs: { zoom: 3, center: _vm.center, options: _vm.options },
        },
        [
          _c("l-tile-layer", {
            attrs: { url: _vm.url, attribution: _vm.attribution },
          }),
          [
            _vm.selectedMarker
              ? _c("l-marker", {
                  key: _vm.countryMarkers.length + 1,
                  attrs: {
                    "lat-lng": _vm.selectedMarker.latLong,
                    icon: _vm.icon,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.filterByCountry(_vm.selectedMarker)
                    },
                  },
                })
              : _vm._e(),
            _vm._l(_vm.countryMarkers, function (marker, index) {
              return _c("l-marker", {
                key: index,
                attrs: { "lat-lng": marker.latLong },
                on: {
                  click: function ($event) {
                    return _vm.filterByCountry(marker)
                  },
                },
              })
            }),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }